/*
 * @Author: Chao Yang
 * @Date: 2020-10-19 15:42:55
 * @LastEditor: Chao Yang
 * @LastEditTime: 2020-10-20 09:38:56
 */
import {
  ChangeDetectorRef,
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { IAdSelectButtonOption } from './i-ad-select-button-option.model';

@Component({
  selector: 'ad-select-button',
  templateUrl: './ad-select-button.component.html',
  styleUrls: ['./ad-select-button.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AdSelectButtonComponent),
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdSelectButtonComponent implements ControlValueAccessor, OnInit {
  @Input()
  options: IAdSelectButtonOption[];
  value: any;
  @Output() onOptionClick: EventEmitter<any> = new EventEmitter();
  @Output() onChange: EventEmitter<any> = new EventEmitter();
  onModelChange = (v) => {};
  onModelTouched = (v) => {};

  constructor(public cd: ChangeDetectorRef) {}

  writeValue(obj: any): void {
    this.value = obj;
    this.cd.markForCheck();
  }

  registerOnChange(fn: any): void {
    this.onModelChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onModelTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {}

  classNames(index: number): string {
    return 'ad-select-button-item ad-select-button-item-' + index;
  }

  ngOnInit(): void {}

  onItemClick(event: Event, option: IAdSelectButtonOption, index: number) {
    event.preventDefault();
    event.stopPropagation();
    const oldValue = this.value;
    this.value = option.value;
    this.onOptionClick.emit({
      option,
      index,
    });
    if (oldValue !== option.value) {
      this.onModelChange(this.value);
      this.onChange.emit({
        originalEvent: event,
        value: this.value,
      });
    }
  }
}
